<template>
  <div class="row">
    <div class="col-12">
      <card :title="table1.title" :subTitle="table1.subTitle">
        <br />
        <div slot="raw-content" class="table-responsive">
          <empty-table :data="table1.data" :columns="table1.columns">
          </empty-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus";
import { EmptyTable } from "@/components";
const tableColumns = ["BIN_BARCODES", "REFERENCE_ID", "TOTAL QTY", "BINS",];

export default {
  components: {
    EmptyTable,
  },
  data() {
    return {
      table1: {
        title: "Emptied Orders",
        columns: [...tableColumns],
        data: [],
      },
    };
  },
  mounted: function (event) {
    const self = this;
    const addToListHandler = function (order) {
      console.log("orderinside list: " + JSON.stringify(order));
      self.table1.data.push(order);
    };
    EventBus.$on("empty", addToListHandler);
  },
};
</script>